import React from "react";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import { Drawer, Button, PageHeader } from "antd";
import { useState } from "react";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import { DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import ClubEntry from "../../components/masters/club/ClubEntry";
import ClubList from "../../components/masters/club/ClubList";
import commonUtility from "../../utility/Utils";
import { ALL_CLUB_XLS_URL, CLUB_LIST_PRINT_URL } from "../../utility/URL";

const Club = () => {
  const [visible, setVisible] = useState(false);
  const [clubAddData, setclubAddData] = useState({
    club_id: 0,
    designation: '',
    club_name: '',
    email: '',
    address: '',
    starting_affiliation_year: '',
    gstin: '',
    mode: "ADD"
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };


  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Club"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,

            <Button key="2" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(ALL_CLUB_XLS_URL)}>
              <FileExcelOutlined /> Excel
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add New Club"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon={<><DrawableCloseIcon /></>}
        >
          <ClubEntry data={clubAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView">
          <div className="form-content">
            {/* <TimeSlotList /> */}
            <ClubList />
          </div>
        </div>

      </div>
    </div>
  );
}
export default Club;